import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import MarqueeStrip from "@/components/site/MarqueeStrip";
import Cases from "@/components/site/Cases";
import BeforeAfter from "@/components/site/BeforeAfter";
import Recognition from "@/components/site/Recognition";
import Testimonials from "@/components/site/Testimonials";
import Portfolio from "@/components/site/Portfolio";
import PostCare from "@/components/site/PostCare";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import { useEffect } from "react";
import axios from "axios";

const trackVisit = () => {
  if (sessionStorage.getItem("visit_logged")) return;
  sessionStorage.setItem("visit_logged", "1");
  const src = new URLSearchParams(window.location.search).get("src");
  let referrer = null;
  try { referrer = document.referrer ? new URL(document.referrer).hostname : null; } catch (e) { referrer = null; }
  if (referrer === window.location.hostname) referrer = null;
  axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/visits`, {
    path: window.location.pathname,
    referrer,
    source: src,
    device: window.innerWidth < 768 ? "mobile" : "desktop",
  }).catch(() => {});
};

export default function Home() {
  useEffect(trackVisit, []);
  return (
    <main className="bg-ivory">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <MarqueeStrip />
      <Cases />
      <BeforeAfter />
      <Recognition />
      <Testimonials />
      <Portfolio />
      <PostCare />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
